const styles = ({ spacing: { unit } }) => ({
  errorAlert: {
    margin: unit * 2
  }
});

export default styles;
